import { OrderNote } from '../models/order-note';
import { dateMapper } from './date.mapper';
import { userMapper } from './user.mapper';

/**
 * Map data to model from DTO.
 * @param {object} dto DTO.
 * @returns {OrderNote}
 */
function fromDto(dto) {
  return new OrderNote({
    id: dto.id,
    orderId: dto.order_id,
    createDate: dateMapper.fromDto(dto.create_date),
    editDate: dateMapper.fromDto(dto.edit_date),
    isActive: dto.active === 'Y',
    user: dto.created_by_user != null ? userMapper.fromDto(dto.created_by_user) : null,
    note: dto.note,
  });
}

export const orderNoteMapper = {
  fromDto,
};
